import * as consts from "@/consts";

export default {
  twoDfire: {
    configKey: "2DFIRE-CONFIG",
    permission: consts.TAKOPOS_SETTING_MODIFY
  },
  pospal: {
    configKey: "POSPAL-CONFIG",
    permission: consts.POSPAL_SETTING_MODIFY
  },
  shopline: {
    configKey: "SHOPLINE-CONFIG",
    permission: consts.SHOPLINE_SETTING_MODIFY
  },
}
